import * as React from 'react';
import * as navigation from 'app/area/shared/navigation';
import { useState } from 'react';
import { ButtonPrimary, Numberbox } from 'ui';
import styles from './open-case.scss';

export interface OpenCaseProps {
  textCaseNo: string;
  textOpenCase: string;
}

export const OpenCaseNumber = ({ textCaseNo, textOpenCase }: OpenCaseProps) => {
  const [caseNumber, setCaseNumber] = useState('');

  const isInteger = caseNumber.match(/^\d+$/) && caseNumber.length < 17 && Number(caseNumber) <= Number.MAX_SAFE_INTEGER;

  function onChangeValue(value: number) {
    setCaseNumber(!!value ? String(value) : '');
  }

  function onOpenCase(event: React.FormEvent) {
    event.preventDefault();
    if (!!Number(caseNumber) && isInteger) {
      navigation.toCaseView(Number(caseNumber));
    }
  }

  return (
    <form onSubmit={onOpenCase} id="openCase">
      <div className={`${styles.openCaseInputContainer} form-group`}>
        <div className={styles.openCaseInputWrapper}>
          <Numberbox
            componentId="caseNumber"
            className={styles.openCaseInput}
            placeholder={textCaseNo}
            value={!caseNumber ? undefined : Number(caseNumber)}
            onChange={onChangeValue}
            useThousand={false} />
        </div>
        <div className="input-group-btn">
          <ButtonPrimary disabled={!isInteger || !Number(caseNumber)} onClick={onOpenCase}>
            {textOpenCase}
          </ButtonPrimary>
        </div>
      </div>
    </form>
  );
};
